<template>
    <div class="content-wrapper">
        <v-card rounded="0">
            <v-img class="event-entry-header-wrapper" :style="{backgroundColor: '#74AE2A'}">
                <v-card-text class="d-flex event-entry-headline-text justify-center align-center">
                    <v-icon class="mdi-icon" color="white">mdi-calendar-month-outline</v-icon>
                    <span style="width: 60vw;">{{ $t("playout.event.today") }}</span>
                </v-card-text>
            </v-img>
            <div class="event-wrapper" :class="{'scroll': todaysEvents.length > 3}" v-if="todaysEvents !== undefined && todaysEvents.length !== 0">
                <template v-for="(event, index) in todaysEvents">
                    <event-entry-view :key="event.id + '-entry'" :event="event" :index="index" :length="todaysEvents.length"></event-entry-view>
                    <v-divider :key="event.id + '-divider'" class="middle-divider" v-if="index !== (todaysEvents.length -1)"></v-divider>
                </template>
            </div>
            <div class="event-wrapper" v-else>
                    <v-row class="menu-entry-empty-text empty-event d-flex justify-center align-center">{{ $t("event.entry-empty") }}</v-row>
            </div>
        </v-card>
    </div>
</template>
<style lang="scss" scoped>
.content-wrapper {
    display: grid;
    grid-template-rows: auto;
    height: 100%;
}
.empty-event {
    min-height: 13vh;
    height: 13vh;
    max-height: 13vh;
}
.event-wrapper{
    height: calc(100% - 15vh);
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 3vh 3vw;
}
.scroll{
    overflow: auto;
}
.event-entry-header-wrapper{
    height: 14vh;
}
.event-entry-headline-text{
    height: 100%;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal bold 5vh/6vh 'RobotoRegular' !important;
    letter-spacing: 2px !important;
    color: white !important;
}
.event-entry-empty-text{
    height: 100%;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal bold 5vh/6vh 'RobotoRegular' !important;
    letter-spacing: 3px !important;
    color: $font-color !important;
}
.mdi-icon{
    font-size: 9vh !important;
}
.hide {
    opacity: 0;
}
</style>
<script>
import moment from 'moment';
export default {
    data() {
        return {
            loading: true,
            now: '',
        }
    },
    created() {
        this.now = moment(moment.now()).format('YYYY-MM-DD');
        this.$store.dispatch({
            type: 'moduleEvents/fetchEvents',
            startDate: this.now,
            endDate: this.now,
        }).catch((error) => {
            if(error.response.status === 401) {
                this.$root.$emit('unauthenticated');
            } else {
                this.apiErrorMessageHandler(error);
            }
        });
    },
    methods: {
        getEventsForDate(date) {
            return this.events.filter(event => {return event.date === date});
        },
    },
    computed: {
        events() {
            return this.$store.getters['moduleEvents/events'];
        },
        todaysEvents() {
            return this.getEventsForDate(this.now);
        },
    }
}
</script>
